import { appConfig } from '../../config/appConfig';

// Full-screen unsupported device message — UNSUPPORTED state.

export function renderUnsupportedScreen(root: HTMLElement): void {
  root.innerHTML = `
    <div class="error-screen">
      <div class="error-screen__content">
        <p class="error-screen__message">${appConfig.copy.unsupported}</p>
      </div>
    </div>
  `;
}
